export const ActivityMap = {
    FETCH_ACTIVITY_START: 'FETCH_ACTIVITY_START',
    FETCH_ACTIVITY_SUCCESS: 'FETCH_ACTIVITY_SUCCESS',
    FETCH_ACTIVITY_FAIL: 'FETCH_ACTIVITY_FAIL',

    OPEN_SINGLE_MODAL: 'OPEN_SINGLE_MODAL',
    CLOSE_SINGLE_MODAL: 'CLOSE_SINGLE_MODAL',

    OPEN_MULTIPLE_MODAL: 'OPEN_MULTIPLE_MODAL',
    CLOSE_MULTIPLE_MODAL: 'CLOSE_MULTIPLE_MODAL',

    SINGLE_ACTIVITY_DELETE_START: 'SINGLE_ACTIVITY_DELETE_START',
    SINGLE_ACTIVITY_DELETE_SUCCESS: 'SINGLE_ACTIVITY_DELETE_SUCCESS',
    SINGLE_ACTIVITY_DELETE_FAIL: 'SINGLE_ACTIVITY_DELETE_FAIL',

    MULTIPLE_ACTIVITY_DELETE_START: 'MULTIPLE_ACTIVITY_DELETE_START',
    MULTIPLE_ACTIVITY_DELETE_SUCCESS: 'MULTIPLE_ACTIVITY_DELETE_SUCCESS',
    MULTIPLE_ACTIVITY_DELETE_FAIL: 'MULTIPLE_ACTIVITY_DELETE_FAIL',
}

export const ActivityActions = {
    openSingleModal: () => ({ type: ActivityMap.OPEN_SINGLE_MODAL }),
    closeSingleModal: () => ({ type: ActivityMap.CLOSE_SINGLE_MODAL }),

    openMultipleModal: () => ({ type: ActivityMap.OPEN_MULTIPLE_MODAL }),
    closeMultipleModal: () => ({ type: ActivityMap.CLOSE_MULTIPLE_MODAL }),

    fetchActivitystart: () => ({ type: ActivityMap.FETCH_ACTIVITY_START }),
    fetchActivitySuccess: (data) => ({ type: ActivityMap.FETCH_ACTIVITY_SUCCESS, payload: data }),
    fetchActivityFail: (data) => ({ type: ActivityMap.FETCH_ACTIVITY_FAIL, payload: data }),

    singleActivityDeleteStart: () => ({ type: ActivityMap.SINGLE_ACTIVITY_DELETE_START }),
    singleActivityDeleteSuccess: (data) => ({ type: ActivityMap.SINGLE_ACTIVITY_DELETE_SUCCESS, payload: data }),
    singleActivityDeleteFail: (data) => ({ type: ActivityMap.SINGLE_ACTIVITY_DELETE_FAIL, payload: data }),

    multipleActivityDeleteStart: (data) => ({ type: ActivityMap.MULTIPLE_ACTIVITY_DELETE_START, payload: data }),
    multipleActivityDeleteSuccess: (data) => ({ type: ActivityMap.MULTIPLE_ACTIVITY_DELETE_SUCCESS, payload: data }),
    multipleActivityDeleteFail: (data) => ({ type: ActivityMap.MULTIPLE_ACTIVITY_DELETE_FAIL, payload: data }),
}